import type { MembersFeatureFlag } from '@library/types/members';
import { useSplitFlag } from '@bo-hooks/useSplitFlag';

export const useMembersFeatureFlags = () => {
  const { treatment: rulesetRevampTreatment } = useSplitFlag({
    flagName: 'RULESETS_REVAMP'
  });

  const isRulesetRevampActive = rulesetRevampTreatment === 'on';

  return {
    isRulesetRevampActive
  } as MembersFeatureFlag;
};
